import React, { FC } from 'react';
import { ButtonStroke } from '@blink/components';
import { ButtonSize } from '@blink/components/src/Button/Button.types';
import { ReactComponent as WalletConnectLogo } from '@blink/assets/src/icons/walletConnectWOborder.svg';

import { useMarginAccountDisconnectionModalStyle } from './MarginAccountDisconnectionModal.style';
import { useHideModal, useModal } from '../ModalWrapperHooks';

export const MarginAccountDisconnectionModal: FC = () => {
    const classes = useMarginAccountDisconnectionModalStyle();

    const { modalProps } = useModal();
    if (!modalProps) {
        return;
    }

    const { disconnectAction } = modalProps;
    const { handleCloseModal } = useHideModal();

    const connectWalletByUriHandler = () => {
        disconnectAction();
        handleCloseModal();
    };

    return (
        <>
            <div className={classes.content}>
                <div className={classes.container}>
                    <WalletConnectLogo />
                </div>

                <div className={classes.text}>
                    Remember, only one margin account can be open at a time.
                    <br />
                    If you disconnect from the current platform, your active trade will close
                    automatically.
                </div>
            </div>
            <div className={classes.buttonWrapper}>
                <ButtonStroke
                    isPrimary={true}
                    size={ButtonSize.md}
                    onClick={connectWalletByUriHandler}
                >
                    Confirm
                </ButtonStroke>
            </div>
        </>
    );
};
